import { isInIframe } from '@shared/utils/isInIframe';
import { useEventUserRole } from '@shared/components/AuthProvider';
import { toPageContainerSlug } from '@shared/utils/migratedCustomPages';
import { useGuestPageContainerBySlugQuery } from '../Custom.graphql.generated';
import { useIsStaysRedesignActive } from '../components/Honeymoon/useIsStaysRedesignActive';

// toPageContainerSlug aligns this hook's cache key with useFetchCustomPageData
// (registrylinks → registry; no-op elsewhere).
export const useCustomData = (_eventId: string, eventHandle: string, pageSlug: string) => {
  const isPreviewing = isInIframe();
  const { isAdmin } = useEventUserRole();
  const containerSlug = toPageContainerSlug(pageSlug);
  const isStaysRedesignActive = useIsStaysRedesignActive();

  const {
    data: pageContainerData,
    loading,
    error,
  } = useGuestPageContainerBySlugQuery({
    variables: {
      payload: {
        eventName: eventHandle,
        pageSlug: containerSlug,
      },
      isAdminDashboard: isPreviewing && isAdmin,
    },
    batchMode: 'fast',
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: false,
    // SSR participation scoped to redesign — non-redesign keeps ssr=false (matches develop).
    ssr: isStaysRedesignActive,
    skip: !containerSlug,
  });

  return {
    loading,
    pageContainerBySlug: pageContainerData?.pageContainerBySlug,
    error,
    isAdmin,
  };
};
